import { render } from "./incomeList.vue?vue&type=template&id=5d879804&scoped=true&ts=true"
import script from "./incomeList.vue?vue&type=script&lang=ts"
export * from "./incomeList.vue?vue&type=script&lang=ts"

import "./incomeList.vue?vue&type=style&index=0&id=5d879804&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d879804"]])

export default __exports__